import apiClient from './apiClient';

class ProjectWorklogService {
  async exportWorklogs(projectId, { startDate, endDate }) {
    try {
      const params = new URLSearchParams();
      if (startDate) params.set('start_date', startDate);
      if (endDate) params.set('end_date', endDate);
      return await apiClient.get(
        `/projects/${projectId}/worklogs/export?${params.toString()}`
      );
    } catch (error) {
      const err = error.response?.data;
      throw new Error(err?.error || 'Failed to export project worklogs');
    }
  }
}

export const projectWorklogService = new ProjectWorklogService();